import ImLoader, { addGlobalShare } from '@ad/ad-im-loader';

const mUi = require('m-ui');

import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { getAccount } from '../../utils/businesslog';

addGlobalShare({
    mUi,
    moment,
    React,
});

enum DollId {
    production = 4835,
    staging = 2802,
}

export const Robot = () => {
    const environment =
        process.env.REACT_APP_RUN_ENV === 'production' ||
        process.env.REACT_APP_RUN_ENV === 'beta' ||
        process.env.REACT_APP_RUN_ENV === 'beta2' ||
        process.env.REACT_APP_RUN_ENV === 'beta3'
            ? 'production'
            : 'staging';
    const [customerId, setCustomerId] = useState<number>(null);

    useEffect(() => {
        const userInfo = getAccount();
        setCustomerId(Number(userInfo?.accountId));
    }, []);

    return (
        <ImLoader
            toolList={[]}
            userConfig={{
                appId: 6,
                uid: customerId,
                environment,
                bizType: 6,
            }}
            initPageSize={10}
            ticketPath="/rest/dsp/robot"
            dollyId={DollId[environment]}
            componentName="App"
            custom={{}}
        />
    );
};
